import React, { Component } from 'react';
import '../../App.css';
import {Helmet} from "react-helmet";

import contact_us_pic from './img/contact_us.jpg';

import office_image1 from './img/abic_office1.jpg';
import office_image2 from './img/abic_office2.jpg';
import office_image3 from './img/abic_office3.jpg';
import office_image4 from './img/abic_office4.jpg';

export default class contact_us extends Component {

  render() {
    return (
      <>
          <Helmet>
            <meta charSet="utf-8" />
            <title>ABIC Immigration【Contact us】</title>
            <meta name="description" content="
                
            " />
          </Helmet>
          <span className="en-part">
          <h2>Contact us</h2>
          <p>
            <div className="content-bg-blue">
              Contact information
            </div>
            Monday to Friday: 9:00am – 5:30pm<br/>
            ABIC Immigration Consulting<br/>
            701 West Georgia Street, Suite 1500<br/>
            Vancouver, B.C., Canada V7Y 1C6<br/>
            Phone: 1-604-688-1956<br/>
            E-mail: abic@ABICanada.com<br/>
          </p>
          <p>
                <table width={"100%"}>
                        <tr className="colored">
                            <td width={"120px"}>
                                <b>
                                  By Appointment
                                </b>
                            </td>
                            <td  width="auto">
                                604-688-1956 (Carolyn / Terry)
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>
                                  Inquiry by email
                                </b>	
                            </td>
                            <td>
                              <a href="mailto:abic@abicanada.com">abic@abicanada.com</a>
                            </td>
                        </tr>
                        <tr className="colored">
                            <td>
                                <b>
                                  Address
                                </b>
                            </td>
                            <td>
                              United Kingdom Building<br/>
                              Suite#1617 - 409 Granville,<br/>
                              Vancouver, BC, V6C 1T2 Canada
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>Website</b>
                            </td>
                            <td>
                                www.ABICanada.com
                            </td>
                        </tr>
                    </table>
                </p>
          <p>
            <div className="content-bg-blue">
            Access and Location
            </div>
          </p>
          <div className="googleMap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2602.660578606996!2d-123.12078022271893!3d49.282828470742835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54867193480e2d27%3A0x521cb969e4fd941e!2s701%20W%20Georgia%20St%20%231500%2C%20Vancouver%2C%20BC%20V6Z%202P6!5e0!3m2!1sen!2sca!4v1768192412049!5m2!1sen!2sca" width="600" height="450" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe><br/>
          </div>
          <br/>
          <div className="overview_pic_container">
            <div className="main-image">
                <img src={office_image1} className="content-pic center"/>
            </div>
            <div className="side-images">
                <img src={office_image2} className="content-pic center"/>
                <img src={office_image3} className="content-pic center"/>
                <img src={office_image4} className="content-pic center"/>
            </div>        
          </div>   
          </span>
    </>
    );
  }
}